export default function(name) {
  let span = document.createElement('span');
  let svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  let useElement = document.createElementNS('http://www.w3.org/2000/svg', 'use');

  span.classList.add('svg-icon');
  span.classList.add(`icon-${name}`);
  /* svgElement.classList.add('svg-icon');
  svgElement.classList.add(`icon-${name}`); */
  useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', `/assets/svg.svg#icon-${name}`);
  svgElement.appendChild(useElement);

  span.appendChild(svgElement);

  return span;
}
